export type HeightTypes = typeof heights;

export const heights = {
	header: '8.6rem',
	headerMegaPanel: '42rem',
	/** header + headerMegaPanel */
	headerMega: '50.6rem',
	headerMobile: '6.4rem',
	/** SubBanner 하단 페이지 탭(TabList) 대략 높이 */
	pageTabBar: '6.4rem',
	/** 학회연혁 시대별 탭 바 높이 */
	historyPeriodBar: '5.2rem',
};
